var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "os_gw_info" }, [
    !_vm.is_load
      ? _c("div", { staticClass: "load_info" }, [_vm._m(0)])
      : _c("div", { staticClass: "info" }, [
          _vm.obj_to_null(_vm.gw_item)
            ? _c("div", { staticClass: "gw_info" }, [
                parseInt(_vm.gw_item.card_count) > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "cursor-pointer btn btn-micro border bg-success active color-white",
                      },
                      [
                        _c("span", {
                          staticClass: "fal fa-sd-card",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass:
                          "cursor-pointer btn btn-micro border bg-warning active color-white",
                      },
                      [
                        _c("span", {
                          staticClass: "fal fa-sd-card",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
              ])
            : _c("div", { staticClass: "gw_empty" }, [_vm._m(1)]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-primary",
        attrs: { type: "button", disabled: "" },
      },
      [_c("span", { staticClass: "spinner-border spinner-border-sm" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "cursor-deny btn btn-micro border bg-danger active color-white",
      },
      [
        _c("span", {
          staticClass: "fal fa-user-alt-slash",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }